/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Project } from '../models/Project'
import type { ProjectArray } from '../models/ProjectArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class ProjectsService {
  /**
   * 📱 Get a list of all projects
   * @returns any OK
   * @throws ApiError
   */
  public static getProjects(): CancelablePromise<{
    data?: ProjectArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/projects',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Get a specific Project by ID
   * @param projectId Id of the project to be completed
   * @returns any OK
   * @throws ApiError
   */
  public static getProject(projectId: number): CancelablePromise<{
    data?: Project
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/projects/{projectId}',
      path: {
        projectId: projectId,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
  /**
   * 📱 Completes a project
   * @param projectId Id of the project to be completed
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static completeProject(
    projectId: number,
    requestBody?: {
      completed_date: string | null
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projects/complete/{projectId}',
      path: {
        projectId: projectId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Completes a projectDate
   * @param projectDateId Id of the projectDate to be completed
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static completeProjectDate(
    projectDateId: number,
    requestBody?: {
      completed_date: string | null
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projectDates/complete/{projectDateId}',
      path: {
        projectDateId: projectDateId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Search for projects
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static searchProjects(requestBody?: {
    query: string
  }): CancelablePromise<{
    data?: ProjectArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projects/search',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
